import React, { useEffect } from 'react';

import { useSelector } from 'react-redux';

import { publish } from 'app/libs/core/PubSub';
import * as way from 'app/libs/core/PubSubWays';

import { Tooltip } from 'antd';

import withTranslations from 'app/components/HOGs/withTranslations';

import { Type } from '../../../../constants/TourPoints';
import { TimeAndDistAccumIcon } from '../../MainMenu/svg';

const TimeAndDistanceAccumulated = ({
  part,
  isTimeDistEnable,
  toggleTimeDist,
  tr,
}) => {
  const points = useSelector(
    (store) => store.tourFullData.activeMultiPart.points
  );
  const distance = useSelector(
    (store) => store.tourFullData.activeMultiPart.distance
  );
  const user = useSelector((store) => store.authentication.user);
  const unitsOfLenght = user ? user.units : 'km';

  const getTimeAndDistanceAccumulated = () => {
    let start = true;
    let unitOfLength = tr.km;
    let prevDist = 0;
    let prevDur = 0;
    if (unitsOfLenght === 'miles' || unitsOfLenght === 'mile')
      unitOfLength = tr.miles;

    return points.map((point) => {
      if (!point || point.isEmpty) return null;
      if (point.type !== Type.START) {
        prevDist += parseInt(point.distance);
        prevDur += parseInt(point.duration);
      }
      if (point.type !== Type.DRAG) {
        let distanceSum = Math.round(parseInt(prevDist / 1000));

        if (unitsOfLenght === 'miles' || unitsOfLenght === 'mile')
          distanceSum = Math.round(distanceSum * 0.621371192);

        let min = Math.floor(prevDur / 60);
        const hour = Math.floor(min / 60);

        min %= 60;

        let duration = '';

        if (hour) duration += `${hour} ${tr.h} `;
        duration += `${min} ${tr.m}`;

        let startClass = '';
        let iconAnchor = [60, 60];
        if (point.type === Type.VIA) iconAnchor = [60, 48];
        if (start) startClass = 'icon_start';
        let html = `<div class="toolboxTimeBlock ${startClass}">`;
        if (start) {
          html += tr.Start;
          start = false;
          iconAnchor = [29, 60];
        } else {
          html += `${distanceSum} ${unitOfLength} - ${duration}`;
        }
        html += '</div>';
        return {
          html,
          iconAnchor,
          className: 'icon_info',
          type: point.type,
          latLng: point.getLatLng(),
        };
      }
      return null;
    });
  };

  const getList = () => getTimeAndDistanceAccumulated().filter((el) => !!el);

  const showTimeDistOnTheMap = () =>
    publish(way.DRIVE_MAP_TOGGLE_TIME_DIST_OF_POINTS, { list: getList() });
  const hideTimeDistOnTheMap = () =>
    publish(way.DRIVE_MAP_TOGGLE_TIME_DIST_OF_POINTS, {});

  useEffect(() => {
    if (isTimeDistEnable) {
      setTimeout(() => showTimeDistOnTheMap(), 0);
    } else {
      hideTimeDistOnTheMap();
    }
  }, [isTimeDistEnable, distance, unitsOfLenght, part]);

  const handleClick = () => {
    toggleTimeDist(!isTimeDistEnable);
  };

  return (
    <Tooltip title={tr['Time and distance - accumulated']} placement="topLeft">
      <div
        className={
          isTimeDistEnable
            ? 'distanceTimeAccumuDiv selected'
            : 'distanceTimeAccumuDiv'
        }
        onClick={handleClick}
        aria-hidden="true"
      >
        <TimeAndDistAccumIcon />
      </div>
    </Tooltip>
  );
};

export default withTranslations(TimeAndDistanceAccumulated);
